import { render, staticRenderFns } from "./myQA.vue?vue&type=template&id=2a854aef&scoped=true"
import script from "./myQA.vue?vue&type=script&lang=js"
export * from "./myQA.vue?vue&type=script&lang=js"
import style0 from "./myQA.vue?vue&type=style&index=0&id=2a854aef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a854aef",
  null
  
)

export default component.exports